import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_BASE || '/api';
const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

export { api };

// Token management
const TOKEN_KEY = 'ar_token';
const USER_KEY = 'ar_user';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUser = () => {
  const u = localStorage.getItem(USER_KEY);
  return u ? JSON.parse(u) : null;
};

export const setAuth = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// Request interceptor - add token
api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptor - handle 401
api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      clearAuth();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth APIs
export const login = (username, password, captcha_id = '', captcha_code = '') =>
  api.post('/auth/login', { username, password, captcha_id, captcha_code });

export const getMe = () => api.get('/auth/me');

export const verifyToken = () => api.get('/auth/verify');

// Import API
export const uploadExcel = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/import/upload', formData);
};

// Dashboard APIs
export const getDashboard = (params = {}) =>
  api.get('/dashboard/full', { params });

export const getData = (params = {}) =>
  api.get('/dashboard/data', { params });

export const getFilters = () =>
  api.get('/dashboard/filters');
